/**
 * Generates a URL-friendly slug from a title string
 * @param title The title string to convert to a slug
 * @returns A URL-friendly slug string
 */
export const generateSlugFromTitle = (title: string): string => {
  if (!title) return '';

  return (
    title
      .toLowerCase()
      .trim()
      // Replace accented characters with their base equivalents
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      // Replace spaces and special characters with hyphens
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      // Remove multiple consecutive hyphens
      .replace(/-+/g, '-')
      // Remove leading and trailing hyphens
      .replace(/^-+|-+$/g, '')
  );
};
